var map = {
	"./21510_warmwind_logo-removebg-preview.png": 63,
	"./BVP_Logo.png": 64,
	"./Bosch_Logo.png": 65,
	"./DFKI_Logo.png": 66,
	"./Fraunhofer_Logo.png": 67,
	"./Lucas_TVS_Logo.png": 68,
	"./RPTU_Logo.png": 69,
	"./Vipul_portrait.jpg": 70,
	"./deeplearning_ai_logo.png": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;